export default __webpack_public_path__ + "static/media/panel4@2x.1291b617.png";